/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserService } from '@shared/services/user.service';
import { Platform, ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { UtilService } from '@shared/utils/util';
import { VoiceRecorder, RecordingData} from 'capacitor-voice-recorder';
import { Directory, Filesystem, } from '@capacitor/filesystem';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MediaService {

  public recording: boolean = false;
  filePath: string | any;
  fileName: string | any;
  public duration: number | any;
  private startRecordingTime: number = (new Date()).getTime();
  public isNative: boolean = true;
  private base64Soung: any;
  /** Last take, used to upload on web where FileTransfer cannot read `/DATA/...`. */
  public lastRecordBase64: string | null = null;
  public lastRecordMimeType: string = 'audio/3gpp';
  private audioRef: any;
  public playbackProgress: number = 0; 
  public currentTimePlayed: number = 0;


  constructor(public http: HttpClient,
    public userService: UserService,
    public util: UtilService,
    private toastCtrl: ToastController,
    private translate: TranslateService,
    public platform: Platform) {
    console.log('Hello MediaServiceProvider Provider');

    platform.ready().then(() => {

      console.log('document.URL: ' + document.URL);
      this.isNative = this.util.isNative();

    });

  }
  ngOnInit() {
    VoiceRecorder.requestAudioRecordingPermission();
  }

  async fileExists(filename: string): Promise<boolean> {

    console.log('filename to check if exists: ' + filename);
    const filePath = this.getFilePathForPlayback();

    console.log('filePath: ' + filePath);

    try {
      await Filesystem.stat({
        path: filePath,
        directory: Directory.Data,
      });

      return true;

    } catch (error) {

      return false;
    }

  }

  public getFilePathForPlayback() {
    let filePath = '';
    if (!this.platform.is('android')) {
      filePath = Directory.Documents;

    } else if (this.platform.is('android')) {
      filePath = Directory.External;
    }
    return filePath;
  }

  public getFilePath() {
    let filePath = '';
    if (!this.platform.is('android')) {
      filePath = Directory.Documents.replace(/file:\/\//g, '');
    } else if (this.platform.is('android')) {
      filePath = Directory.External.replace(/file:\/\//g, '');
    }
    return filePath;
  }

  startRecord() {
    console.log('Will start to startRecord..');
    this.lastRecordBase64 = null;
    this.fileName = this.buildRecordingFileName('audio/3gpp');

    const _folder = this.getFilePathForPlayback();
    this.filePath = this.getFilePath() + this.fileName;

    console.log('Will set recording to true..');
    console.log('Will create file: ' + this.filePath);
    console.log('Will create file: ' + this.fileName);

    console.log('Will call startRecord on MediaObject..');
    this.startRecordingTime = (new Date()).getTime();
    VoiceRecorder.startRecording();
    console.log('Will set recording to true..');
    this.recording = true;


    // Filesystem.writeFile({
    //   path: this.fileName, 
    //   directory: Directory.Data,
    //   data: ''
    // }).then((createResult) => {
    //   console.log('startRecord createFile result: ' + JSON.stringify(createResult));

    //   console.log('Will call startRecord on MediaObject..');
    //   this.startRecordingTime = (new Date()).getTime();
    //   VoiceRecorder.startRecording();
    //   console.log('Will set recording to true..');
    //   this.recording = true;
    // }).catch((err) => {
    //   console.log('startRecord createFile error: ' + JSON.stringify(err));
    // });


  }

  async stopRecord(): Promise<any> {
    try {
      const result: RecordingData = await VoiceRecorder.stopRecording();
      this.recording = false;

      if (result.value && result.value.recordDataBase64) {
        const recordData = result.value.recordDataBase64;
        const mimeType = result.value.mimeType || 'audio/3gpp';
        console.log('recordDataBase64 length: ' + recordData.length);
        this.lastRecordBase64 = recordData;
        this.lastRecordMimeType = mimeType;
        this.fileName = this.buildRecordingFileName(mimeType);

        const fileAudio = await Filesystem.writeFile({
          path: this.fileName,
          directory: Directory.Data,
          data: recordData
        });
        const stopRecordingTime = (new Date()).getTime();
        this.duration = result.value.msDuration
          ? Math.max(1, Math.ceil(result.value.msDuration / 1000))
          : Math.ceil((stopRecordingTime - this.startRecordingTime) / 1000);

        console.log("fileAudio.uri:" + fileAudio.uri);
        return fileAudio.uri;
      }
    } catch (error) {
      console.error('Error stopping recording:', error);
      this.recording = false;
      return null;
    }
  }

  private buildRecordingFileName(mimeType: string): string {
    const stamp = 'record' + new Date().getDate() + new Date().getMonth() + new Date().getFullYear()
      + new Date().getHours() + new Date().getMinutes() + new Date().getSeconds();
    return stamp + this.extensionFromMime(mimeType);
  }

  private extensionFromMime(mimeType: string): string {
    const mime = (mimeType || '').toLowerCase();
    if (mime.includes('webm')) {
      return '.webm';
    }
    if (mime.includes('mp4') || mime.includes('m4a') || mime.includes('aac')) {
      return '.m4a';
    }
    if (mime.includes('ogg')) {
      return '.ogg';
    }
    if (mime.includes('wav')) {
      return '.wav';
    }
    return '.3gp';
  }

  private messagePlaying: any = null;

  playAudio(aMessage: any) {
    console.log('playAudio aMessage: ' + JSON.stringify(aMessage));
    let fileAudio: any;
    let fileId: any

    try {
      fileAudio = JSON.parse(aMessage.message);
      fileId = fileAudio.fileId
    } catch (error) {
      fileId = aMessage.fileId
      aMessage.isPaused = false;
    }
    console.log(fileAudio)

    this.stopOtherAudio();
    this.stopPreview(); // audio do chat e previa da gravacao nunca tocam juntos

    if (aMessage.isPaused) {
      this.audioRef.play();
      aMessage.isPlaying = true;
      aMessage.isPaused = false;
      return;
    }

    const url: string = `${environment.mainServer}/soul/audio/${fileId}`;
    console.log("Audio URL: ", url);

    this.audioRef = new Audio(url);
    this.messagePlaying = aMessage; // Esta é agora a mensagem ativa gerenciada pelo audioRef

    // Listener para atualizações de tempo
    this.audioRef.ontimeupdate = () => {
        if (this.audioRef && this.messagePlaying === aMessage) {
            this.messagePlaying.currentTimePlayed = this.audioRef.currentTime;
            const duration = parseFloat(this.messagePlaying.duration as string);
            if (duration > 0) {
                this.messagePlaying.playbackProgress = (this.audioRef.currentTime / duration) * 100;
            } else {
                this.messagePlaying.playbackProgress = 0;
            }
            // Se a UI não atualizar, pode ser necessário NgZone:
            // this.ngZone.run(() => {});
        }
    };

    // Listener para quando o áudio termina
    this.audioRef.onended = () => {
        if (this.messagePlaying === aMessage) {
            console.log('Audio ended for message:', aMessage.message);
            this.messagePlaying.isPlaying = false;
            this.messagePlaying.isPaused = false;
            const duration = parseFloat(this.messagePlaying.duration as string);
            this.messagePlaying.currentTimePlayed = duration;
            this.messagePlaying.playbackProgress = 0;

            this.clearAudioRefListeners(); // Limpa listeners
        }
    };

    // Listener para quando o áudio pode começar a tocar
    this.audioRef.oncanplay = () => {
        if (this.audioRef && this.messagePlaying === aMessage) {
            console.log('Audio can play for message:', aMessage.message);
            this.audioRef.play().then(() => {
                if (this.messagePlaying === aMessage) {
                    this.messagePlaying.isPlaying = true;
                }
            }).catch((error: Error) => {
                console.error("Error in oncanplay play attempt:", error);
                if (this.messagePlaying === aMessage) {
                    this.messagePlaying.isPlaying = false;
                }
            });
        }
    };

    // Listener para erros ao carregar/tocar o áudio
    this.audioRef.onerror = (event: Event | string) => {
        console.error("Error with audio element. Message:", aMessage.message, "Event:", event);
        if (this.audioRef && this.audioRef.error) {
            console.error("Audio URL:", this.audioRef.currentSrc || url);
            console.error("Error code:", this.audioRef.error.code, "Message:", this.audioRef.error.message);
        }
        if (this.messagePlaying === aMessage) {
            this.messagePlaying.isPlaying = false;
            this.messagePlaying.isPaused = false;
            this.messagePlaying.currentTimePlayed = 0;
            this.messagePlaying.playbackProgress = 0;
            this.clearAudioRefListeners(); // Limpa listeners
        }
    };

    this.audioRef.load(); // Inicia o carregamento

    // Tentativa inicial de play (navegadores modernos podem enfileirar)
    this.audioRef.play().then(() => {
      if (this.messagePlaying === aMessage && this.audioRef?.duration && this.audioRef.duration > 0) {
        this.messagePlaying.isPlaying = true;
      }
    }).catch((error: { message: any; }) => {
        console.warn(`Initial play() for ${aMessage.message} caught error (often autoplay policy): ${error.message}`);
    });
  }

  private clearAudioRefListeners() {
    if (this.audioRef) {
        this.audioRef.ontimeupdate = null;
        this.audioRef.onended = null;
        this.audioRef.oncanplay = null;
        this.audioRef.onerror = null;
    }
  }
  
    pauseAudio(aMessage: any) {
    this.audioRef.pause();
    aMessage.isPlaying = false;
    aMessage.isPaused = true;
  }

  // ---- Prévia da gravação local (ouvir antes de enviar) ----
  //
  // O playAudio() acima só toca áudio JÁ ENVIADO: ele monta a URL do servidor a
  // partir do fileId. Para ouvir antes de mandar, a fonte tem que ser a própria
  // gravação — e o stopRecord() sempre deixa ela em lastRecordBase64 +
  // lastRecordMimeType, tanto na web quanto no nativo.
  //
  // Um `data:` URI toca nos dois ambientes; um caminho file:// do nativo exigiria
  // Capacitor.convertFileSrc(), que não é usado em lugar nenhum deste projeto.
  //
  // Elemento próprio, separado do audioRef do chat, para que uma prévia não mexa
  // no estado de reprodução das mensagens.
  private previewRef: HTMLAudioElement | null = null;
  private previewSrc: string | null = null;
  public previewPlaying: boolean = false;

  /** Há gravação disponível para ouvir? */
  hasPreview(): boolean {
    return !!this.lastRecordBase64;
  }

  /** Toca, ou pausa se já estiver tocando. Sem gravação, não faz nada. */
  togglePreview(): void {
    if (this.previewPlaying && this.previewRef) {
      this.previewRef.pause();
      this.previewPlaying = false;
      return;
    }

    if (!this.lastRecordBase64) {
      return;
    }
    const src = `data:${this.lastRecordMimeType || 'audio/3gpp'};base64,${this.lastRecordBase64}`;

    this.stopOtherAudio(); // não concorrer com áudio de mensagem do chat

    // Gravação nova: descarta o player antigo. Retomar de onde parou só vale
    // quando é a MESMA gravação (usuário pausou e voltou).
    if (!this.previewRef || this.previewSrc !== src) {
      this.stopPreview();
      this.previewRef = new Audio(src);
      this.previewSrc = src;
      this.previewRef.onended = () => {
        this.previewPlaying = false;
        if (this.previewRef) {
          this.previewRef.currentTime = 0;
        }
      };
      this.previewRef.onerror = () => {
        console.error('Erro ao tocar a prévia da gravação');
        this.previewPlaying = false;
      };
    }

    this.previewPlaying = true;
    this.previewRef.play().catch((error: Error) => {
      console.error('play() da prévia falhou: ' + error.message);
      this.previewPlaying = false;
    });
  }

  /** Encerra e descarta o player da prévia. Idempotente. */
  stopPreview(): void {
    if (this.previewRef) {
      this.previewRef.pause();
      this.previewRef.onended = null;
      this.previewRef.onerror = null;
      this.previewRef = null;
    }
    this.previewSrc = null;
    this.previewPlaying = false;
  }

  stopOtherAudio() {
    if (this.messagePlaying != null && this.messagePlaying.isPlaying) {
      this.audioRef.pause();
      this.audioRef.remove();
      this.audioRef.currentTime = 0;
      this.messagePlaying.isPlaying = false;
      this.messagePlaying.isPaused = false;
    }
  }

  public deleteLastLocalAudioIfExists() {
  }

}

